export default class BroadcastUserInfo
{
    constructor()
    {

        this.arrListener = [];

        if (typeof BroadcastChannel === 'function')
        {
            this.channel = new BroadcastChannel("les-as-de-l-info_user-info");
            this.channel.onmessage = (event) => this.onMessage(event);
        }
    }

    addListener ( fct)
    {
        this.arrListener.push(fct);
    }

    broadcastEmail ()
    {
        if (!this.channel)
        {
            return;
        }

        const email = document.querySelector("#email");


        if (email)
        {
            const strEmail = email.value;


            this.channel.postMessage({ email: strEmail})
        }

    }

    broadcastName (name)
    {
        if (!this.channel)
        {
            return;
        }

        this.channel.postMessage({ name})
    }

    onMessage (event)
    {

        for (let i = 0; i < this.arrListener.length; i++)
        {
            let listener = this.arrListener[i];
            listener(event);
        }
    }


}
